// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import loadMore from "./loadMore";
import mnrMegaMenu from "./mnrMegaMenu";
import mnrLanguagePref from "./mnrLanguage";
import contentEnhance from "./contentEnhance";
import populateCardThumbnails from "./cardThumbnails";

menuOpen();
loadMore();
mnrMegaMenu();
mnrLanguagePref();
contentEnhance();
populateCardThumbnails();
